import React, { Fragment, useEffect, useState } from "react";
import FcardContact from "../../components/FcardContact/FcardContact";
import FcardGroup from "../../components/FcardGroup/FcardGroup";
import FcardPageTitle from "../../components/FcardPageTitle/FcardPageTitle";
import { useNavigate } from "react-router";
import FBannerSpend from "../../components/FBannerSpend/FBannerSpend";
import FInput from "../../components/FInput/FInput";
import FBannerSpendResponsive from "../../components/FBannerSpendResponsive/FBannerSpend";
import { useFCurrencyExchange } from "./hooks/useFCurrencyExchange";
import { useCalcScreen } from "./hooks/useCalcScreen";
import FInputt from "../../components/FInputt/FInputt";
import Fselect from "../../components/Finputs/Fselect/Fselect";
import FInputText from "../../components/Finputs/FInputText/FInputText";
import Fbutton from "../../components/Finputs/FButton/Fbutton";
import FBannerTitle from "../../components/FspendComponents/FBannerSpend/FBannerTitle";
import FContainer from "../../components/FContainer/FContainer";

const CalcScreen = ({ param }) => {
  const route = useNavigate();
  const [monto, setMonto] = useState(0);

  const { error, exchangeData, setError, nextScreen, setExchangeData } =
    useCalcScreen();

  const {
    fromCurrency,
    toCurrency,
    originCurrencyId,
    destinationCurrencyId,
    exchangeRate,
    exchangeAmount,
    setcapturedAmount,
    capturedAmount,
    setOriginCurrencyId,
    setDestinationCurrencyId,
    getExchange,
    setAmount,
    changeSelectItem,
    setFromCurrencyValue,
    setToCurrencyValue,
    fromCurrencyValue,
    toCurrencyValue,
  } = useFCurrencyExchange();

  const returnData = async () => {
    let resp = {
      originCurrencyId: originCurrencyId,
      destinationCurrencyId: destinationCurrencyId,
      capturedAmount: capturedAmount,
      exchangeAmount: exchangeAmount,
      exchangeRate: exchangeRate,
    };
    await setExchangeData(resp);
  };

  useEffect(() => {
    async function returnExchangeData() {
      await getExchange(originCurrencyId, destinationCurrencyId);
    }
    returnExchangeData();
  }, []);

  useEffect(() => {
    returnData();
  }, [capturedAmount]);

  useEffect(() => {
    setAmount(capturedAmount);
  }, [changeSelectItem]);

  useEffect(() => {
    async function returnExchangeData() {
      await returnData();
      await getExchange(originCurrencyId, destinationCurrencyId);
      await setAmount(capturedAmount);
    }

    returnExchangeData();
  }, [originCurrencyId, destinationCurrencyId]);

  useEffect(() => { }, [originCurrencyId]);

  return (
    <>
      <FBannerTitle
        title="¿Cuánto deseas pedir?"
        imageUrl={require("../../components/assets/images/recharge.png")}
      />
      <FContainer>
        <div className="border-0 w-full gap-4 grid grid-cols-2 ">
          <div className="col-span-1 grid row-span-2">
            <div className="border-0 row-span-1">
              <Fselect
                type="SelectIcon"
                arrowIcon={false}
                title="Pagar fiado con"
                value={fromCurrency[1]}
                options={fromCurrency}
                onChange={async (data) => {
                  await changeSelectItem(
                    originCurrencyId,
                    data.id,
                    toCurrency,
                    setOriginCurrencyId,
                    "ORIGIN"
                  );
                }}
              />
            </div>
            <div className="border-0 row-span-1">
              <Fselect
                type="SelectIcon"
                arrowIcon={false}
                title="Para gastar en"
                value={toCurrency[0]}
                options={toCurrency}
                onChange={async (data) => {
                  await changeSelectItem(
                    originCurrencyId,
                    data.id,
                    toCurrency,
                    setOriginCurrencyId,
                    "ORIGIN"
                  );
                }}
              />
            </div>
          </div>
          <div className="col-span-1 grid row-span-2">
            <div className="border-0 row-span-1">
              <FInputText
                type="CurrencyInput"
                maxLength={10}
                value={monto}
                onChange={async (value) => {
                  setMonto(value == undefined ? 0 : value)
                  await setAmount(value);
                }}
              />
            </div>
            <div className="border-0 row-span-1">
              <FInputText type="CurrencyInput" value={isNaN(exchangeAmount) ? 0 : exchangeAmount} />
            </div>
          </div>
          <div className="col-span-4">
              <p className="text-Secondary font-bold">Tipo de cambio</p>
              <p className="">$1.00 {exchangeRate?.originCurrency?.iso} = $20.00 {exchangeRate.destinationCurrency?.iso}</p>
            </div>
          <div className="col-span-2 border-0">
            <div className="px-[20%]">
              <Fbutton
                value="Continuar"
                onClick={() => {
                  nextScreen();
                }}
              />
            </div>
          </div>
        </div>
      </FContainer>
    </>
  );
};

export default CalcScreen;
